import { render } from "./doubleBarChart.vue?vue&type=template&id=4006dfec&scoped=true"
import script from "./doubleBarChart.vue?vue&type=script&lang=js"
export * from "./doubleBarChart.vue?vue&type=script&lang=js"

import "./doubleBarChart.vue?vue&type=style&index=0&id=4006dfec&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4006dfec"]])

export default __exports__